import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';
import { PiSwimmingPool, PiTreeEvergreen } from 'react-icons/pi';
import { CgGym } from 'react-icons/cg';
import { GiMeditation, GiPathDistance } from 'react-icons/gi';
import { MdOutlineOutdoorGrill, MdOutlinePeople, MdOutlineStream, MdOutlineVilla } from 'react-icons/md';
import { FaChild } from 'react-icons/fa';
import { GrYoga } from 'react-icons/gr';
import { IoCarSportOutline, IoShieldHalf, IoStorefrontOutline } from 'react-icons/io5';
import { textMap } from '../../../../components/ColorMappingOptions';

function NinaAziziLeily({
    language
}) {
    const color = "purple";

    const images = [
        "/assets/images/projects/azizi-leily/1.webp",
        "/assets/images/projects/azizi-leily/2.webp",
        "/assets/images/projects/azizi-leily/3.webp",
        // "/assets/images/projects/azizi-leily/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-leily/poster.jpg";
    // const webm = "/assets/images/projects/azizi-leily/hero.webm";
    const video = "/assets/images/projects/azizi-leily/azizi-leily.mp4";

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold neon-white">
                        <span className={`text-${color}-300 neon-${color}`}>
                            الوحدات محدودة ..
                        </span>
                        <br />
                        فرصتك للتملك بجانب برج خليفة
                        <br />
                        سجل بياناتك الآن
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl">
                        <span className={`px-2 text-2xl text-${color}-300 neon-${color}`}>
                            Limited units..
                        </span>
                        <br />
                        Own your own property next to Burj Khalifa
                        <br />
                        Register now to receive full details
                    </h1 >
                )
                }

            </>
        );
    }

    // const gridDetails = [
    //     {
    //         "topic": language == "ar" ? "أنواع الوحدات" : "Unit Types",
    //         "text": language == "ar" ? "استوديو، غرفة وصالة، غرفتين، بنتهاوس" : "Studio, 1BR, 2BR, Penthouses",
    //     },
    //     {
    //         "topic": language == "ar" ? "الأسعار تبدأ من" : "Starting Price",
    //         "text": language == "ar" ? (isUAE ? "828,000 درهم" : "225 ألف دولار") : (isUAE ? "AED 828K" : "USD 225K"),
    //     },
    //     {
    //         "topic": language == "ar" ? "أقساط شهرية" : "Payment Plan",
    //         "text": language == "ar" ? "50٪ بعد التسليم • تسليم في ديسمبر 2027"
    //             : "50% post-handover • Handover December 2027",
    //     },
    // ];

    const imageDetails = {
        // "title": "✨ عرض حصري لفترة محدودة ✨",
        // "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
        title: language === "ar" ?
            "✨ عرض حصري لفترة محدودة ✨" :
            "✨ Limited-Time Exclusive Offer ✨",

        desc: language === "ar"
            ? "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
            : "Book your unit now and enjoy a fully equipped kitchen with all Siemens German appliances."

    };

    const amenityDetails = [
        {
            // "icon": "/assets/images/icons/pool.svg",
            icon: <PiSwimmingPool size={60} className={textMap[color]} />,
            en_text: "Infinity Rooftop Pool",
            ar_text: "مسبح إنفينيتي على السطح",
        },
        {
            // "icon": "/assets/images/icons/gym.svg",
            icon: <CgGym size={60} className={textMap[color]} />,
            en_text: "Fully Equipped Gym",
            ar_text: "نادي صحي مجهز",
        },
        {
            icon: <GiMeditation size={60} className={textMap[color]} />,
            en_text: "Wellness Spa & Sauna",
            ar_text: "سبا ومنطقة ساونا",
        },
        {
            icon: <MdOutlineStream size={60} className={textMap[color]} />,
            en_text: "Steam Room",
            ar_text: "غرفة بخار",
        },
        {
            icon: <FaChild size={60} className={textMap[color]} />,
            en_text: "Kids’ Play Area",
            ar_text: "منطقة ألعاب للأطفال",
        },
        {
            icon: <PiTreeEvergreen size={60} className={textMap[color]} />,
            en_text: "Landscaped Gardens",
            ar_text: "حدائق منسقة",
        },
        {
            icon: <GiPathDistance size={60} className={textMap[color]} />,
            en_text: "Jogging Tracks",
            ar_text: "مسارات للجري",
        },
        {
            icon: <GrYoga size={60} className={textMap[color]} />,
            en_text: "Yoga & Zen Areas",
            ar_text: "مناطق يوغا واستجمام",
        },
        {
            icon: <MdOutlineOutdoorGrill size={60} className={textMap[color]} />,
            en_text: "BBQ Area",
            ar_text: "منطقة شواء",
        },
        {
            icon: <MdOutlinePeople size={60} className={textMap[color]} />,
            en_text: "Multipurpose Hall",
            ar_text: "قاعة متعددة الاستخدامات",
        },
        {
            icon: <MdOutlineVilla size={60} className={textMap[color]} />,
            en_text: "Club House",
            ar_text: "نادي ترفيهي",
        },
        {
            icon: <IoStorefrontOutline size={60} className={textMap[color]} />,
            en_text: "Retail & Dining Outlets",
            ar_text: "محلات تجارية ومطاعم",
        },
        {
            icon: <IoShieldHalf size={60} className={textMap[color]} />,
            en_text: "24/7 Security",
            ar_text: "أمن وحراسة على مدار الساعة",
        },
        {
            icon: <IoCarSportOutline size={60} className={textMap[color]} />,
            en_text: "Covered Parking",
            ar_text: "مواقف سيارات مغطاة",
        },
    ];

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/riviera",
                        ar: "/projects/azizi/riviera/ar",
                        fa: "/projects/azizi/riviera/fa",
                        tr: "/projects/azizi/riviera/tr",
                    }}
                /> */}
            <ColorLandingPage
                color={color}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                imageDetails={imageDetails}
                amenityDetails={amenityDetails}
                base_url={FINDESTATES_URL}
                developer="Azizi"
                project="Leily"
                projectName="Leily"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "4 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={!isUAE ? 6 : 6}
            />
        </>
    );
}

export default NinaAziziLeily;
